<div class="container">
  <div style="text-align: center" class="index-PageNotFoundContainer">
    <div>
      <!-- <p>
        You searched for
        <span class="index-searchTerm"> kjnhbghvfvbh </span>
      </p> -->
      <img
        loading="lazy"
        class="index-notFoundImage"
        src="assets/images/not-found.png"
      />
      <p class="index-infoBig">We couldn't find any matches!</p>
      <p class="index-infoSmall">
        Please check the spelling or try searching something else
      </p>
    </div>
    <div class="index-searchBox">
      <input
        type="text"
        class="index-inputBox"
        value=""
        (keyup.enter)="search($event.target.value)"
        #slug
        placeholder="Shoes, T-shirts, Tops etc."
      /><a (click)="search(slug.value)" class="index-searchBtn"> SEARCH </a>
    </div>
    <div class="index-popularSearch">
      <span>Popular searches: </span
      ><a href="/nike-shoes?src=404">Nike Shoes,</a
      ><a href="/woodland-shoes?src=404">Woodland Shoes,</a
      ><a href="/sports-shoes?src=404">Adidas Shoes,</a
      ><a href="/titan?src=404">Titan Watches,</a
      ><a href="/fila-shoes?src=404">Fila Shoes,</a
      ><a href="/puma-shoes?src=404">Puma Shoes,</a
      ><a href="/fastrack-watches?src=404">Fastrack Watches</a>
    </div>
  </div>
</div>
